import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0571a547"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-form" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "alert alert-success" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Thanks for contacting us! We'll take a look and get back to you as soon as we can. ", -1))
const _hoisted_5 = {
  key: 1,
  class: "task-content"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "options" }
const _hoisted_9 = {
  key: 0,
  class: "inquiry-type"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Reason", -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 1,
  class: "priority"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Priority", -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-fields" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-sm-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "form-label"
}, "First name", -1))
const _hoisted_22 = ["readonly"]
const _hoisted_23 = { class: "col-sm-6" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "form-label"
}, "Last name", -1))
const _hoisted_25 = ["readonly"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, "Email", -1))
const _hoisted_27 = ["readonly"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "subject",
  class: "form-label"
}, "Subject", -1))
const _hoisted_29 = ["readonly"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "message",
  class: "form-label"
}, "Message", -1))
const _hoisted_31 = ["readonly"]
const _hoisted_32 = { class: "help-text-sm" }
const _hoisted_33 = {
  key: 2,
  class: "files"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Attach a file (up to 50 MB)", -1))
const _hoisted_35 = { class: "file-selector" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 0,
  class: "file-error"
}
const _hoisted_39 = {
  key: 1,
  class: "help-text-sm mt-1"
}

import { ref, computed, onMounted, nextTick, reactive, watch } from 'vue'
import { useRouter } from 'vue-router'
import { usePageTitle } from '@webapp/util/AppUtil'
import { useSupportTicketStore } from '@webapp/gp/SupportTicketStore'
import { NewSupportTicket, SupportInquiryType, SupportTicket, SupportTicketPriority, supportInquiryTypeInfos } from '@webapp/gp/GroupAdminModel'
import { AddressUtil } from '@webapp/util/AddressUtil'
import { LoadMode } from '@webapp/util/AsyncData'
import { useUserStore } from '@webapp/gp/UserStore'
import { useTokenManager } from '@webapp/auth/TokenManager'
import { CheckIcon, ToolIcon, XIcon } from '@zhuowenli/vue-feather-icons'
import { AsyncUtil } from '@webapp/util/AsyncUtil'
import { Environment } from '@webapp/util/Environment'
import { ByteSizeUtil } from '@webapp/util/ByteSizeUtil'
import ContactInquiryType from './ContactInquiryType.vue'
import VueTurnstile from 'vue-turnstile'

const MaxMessageLength = 2000

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactForm',
  props: {
    noGreeting: { type: Boolean },
    small: { type: Boolean },
    inquiryType: {},
    priority: {},
    noFile: { type: Boolean },
    disabled: { type: Boolean },
    isValid: { type: Boolean }
  },
  emits: [
  'update:isValid'
],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;



__expose({
  reset,
  submitTicket,
})



const orderedPriorities = [
  { value: SupportTicketPriority.High, text: "High", iconText: "🔥" },
  { value: SupportTicketPriority.Medium, text: "Normal", iconText: "😶" },
  { value: SupportTicketPriority.Low, text: "Low", iconText: "⬇️" },
]

const tsKey = Environment.get('TURNSTILE_KEY')

const router = useRouter()
const tokenManager = useTokenManager()
const userStore = useUserStore()
const supportTicketStore = useSupportTicketStore()

const busyRef = ref(false)
const newTicket = reactive(new NewSupportTicket())
const ticketRef = ref<SupportTicket>()
const selectedFileRef = ref<File>()
const captchaCodeRef = ref("")
// Turnstile must render after a nextTick delay so its container element exists in the DOM.
// Without this, Cloudflare's script fires before Vue flushes the v-if block, causing
// "Invalid type for parameter container" errors that leave the captcha broken.
const turnstileReadyRef = ref(false)
const fileInputRef = ref<HTMLInputElement>()

const userRef = computed(() => userStore.getAsyncSelf(LoadMode.EnsureLoaded)?.data)
const isAnonymousRef = computed(() => !tokenManager.current.isValid)
const charsRemainingRef = computed(() => MaxMessageLength - (newTicket.message?.length ?? 0))
const canEditRef = computed(() => !busyRef.value && !ticketRef.value && !props.disabled)
const isValidAddressRef = computed(() => AddressUtil.isValidEmail(newTicket.email))
const hasIdentityRef = computed(() => tokenManager.current.isValid || (newTicket.lastName && isValidAddressRef.value))
const captchaAppearanceRef = computed(() => Environment.isDevelopment() && router.currentRoute.value.query.forceCaptcha ? "always" : "interaction-only")
const isHumanRef = computed(() => !isAnonymousRef.value || !!captchaCodeRef.value)
const fileErrorRef = computed(() => {
  if (selectedFileRef.value && selectedFileRef.value.size > 50 * 1024 * 1024) {
    return "The selected file is too large. Consider zipping it first."
  }
  return undefined
})
const canSubmitRef = computed(() => hasIdentityRef.value && !!newTicket.subject && isHumanRef.value && !fileErrorRef.value)

usePageTitle("Contact us")

onMounted(async () => {
  await nextTick()
  turnstileReadyRef.value = true
})

function reset() {
  // reset state
  Object.assign(newTicket, new NewSupportTicket())
  newTicket.subject = new URLSearchParams(window.location.search).get('subject') ?? ''
  newTicket.inquiryType = props.inquiryType ?? SupportInquiryType.Question
  newTicket.priority = props.priority ?? SupportTicketPriority.Medium
  ticketRef.value = undefined
  captchaCodeRef.value = ""
}

function onFileSelected(e: Event) {
  const input = e.target as HTMLInputElement
  if (input.files && input.files.length > 0) {
    selectedFileRef.value = input.files[0]
  }
}

function removeFile() {
  selectedFileRef.value = undefined
  if (fileInputRef.value) {
    fileInputRef.value.value = ''
  }
}

watch(canSubmitRef, () => emit('update:isValid', canSubmitRef.value))

async function submitTicket() {
  try {
    busyRef.value = true
    newTicket.captchaCode = captchaCodeRef.value
    const ticketId = await AsyncUtil.atLeast(500, supportTicketStore.addAsync(newTicket))

    if (selectedFileRef.value) {
      await supportTicketStore.addFileAsync(ticketId, selectedFileRef.value)
    }

    ticketRef.value = supportTicketStore.asyncSupportTickets.get(ticketId)?.data // already loaded
    return ticketRef.value
  }
  finally {
    busyRef.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (ticketRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(CheckIcon), { size: "1.8x" }),
            _hoisted_4
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!_ctx.noGreeting)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (userRef.value)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_6, " Hi " + _toDisplayString(userRef.value.givenName) + ", how can we help? ", 1))
                  : (_openBlock(), _createElementBlock("h4", _hoisted_7, " How can we help? "))
              ], 64))
            : _createCommentVNode("", true),
          (!_ctx.inquiryType && !_ctx.small)
            ? (_openBlock(), _createBlock(ContactInquiryType, {
                key: 1,
                disabled: !canEditRef.value,
                modelValue: newTicket.inquiryType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newTicket.inquiryType) = $event))
              }, null, 8, ["disabled", "modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.inquiryType && _ctx.small)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newTicket.inquiryType) = $event)),
                    disabled: !canEditRef.value
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(supportInquiryTypeInfos), (t) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: t.value,
                        value: t.value
                      }, _toDisplayString(t.text), 9, _hoisted_12))
                    }), 128))
                  ], 8, _hoisted_11), [
                    [_vModelSelect, newTicket.inquiryType]
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.priority)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newTicket.priority) = $event)),
                    disabled: !canEditRef.value
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(orderedPriorities, (p) => {
                      return _createElementVNode("option", {
                        key: p.value,
                        value: p.value
                      }, [
                        (p.iconText)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(p.iconText), 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(p.text), 1)
                      ], 8, _hoisted_16)
                    }), 64))
                  ], 8, _hoisted_15), [
                    [_vModelSelect, newTicket.priority]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            (isAnonymousRef.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "firstName",
                        readonly: !canEditRef.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newTicket.firstName) = $event))
                      }, null, 8, _hoisted_22), [
                        [_vModelText, newTicket.firstName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        id: "lastName",
                        readonly: !canEditRef.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newTicket.lastName) = $event))
                      }, null, 8, _hoisted_25), [
                        [_vModelText, newTicket.lastName]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_26,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "email",
                      readonly: !canEditRef.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newTicket.email) = $event))
                    }, null, 8, _hoisted_27), [
                      [_vModelText, newTicket.email]
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _hoisted_28,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "subject",
                readonly: !canEditRef.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newTicket.subject) = $event))
              }, null, 8, _hoisted_29), [
                [_vModelText, newTicket.subject]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_30,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control message-body",
                id: "message",
                readonly: !canEditRef.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newTicket.message) = $event)),
                maxlength: MaxMessageLength
              }, null, 8, _hoisted_31), [
                [_vModelText, newTicket.message]
              ]),
              _createElementVNode("div", _hoisted_32, "Characters remaining: " + _toDisplayString(charsRemainingRef.value.toLocaleString()), 1)
            ])
          ]),
          (!isAnonymousRef.value && !_ctx.noFile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("input", {
                    type: "file",
                    ref_key: "fileInputRef",
                    ref: fileInputRef,
                    class: _normalizeClass(["form-control form-control-sm", { empty: !selectedFileRef.value }]),
                    disabled: !canEditRef.value,
                    onChange: onFileSelected
                  }, null, 42, _hoisted_36),
                  (selectedFileRef.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-inline btn-link link-dark",
                        type: "button",
                        onClick: removeFile,
                        disabled: busyRef.value
                      }, [
                        _createVNode(_unref(XIcon))
                      ], 8, _hoisted_37))
                    : _createCommentVNode("", true)
                ]),
                (fileErrorRef.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(fileErrorRef.value), 1))
                  : _createCommentVNode("", true),
                (selectedFileRef.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(ByteSizeUtil).toReadableText(selectedFileRef.value.size)), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (isAnonymousRef.value && turnstileReadyRef.value)
            ? (_openBlock(), _createBlock(_unref(VueTurnstile), {
                key: 3,
                class: "captcha",
                "site-key": _unref(tsKey),
                appearance: captchaAppearanceRef.value,
                theme: "light",
                modelValue: captchaCodeRef.value,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((captchaCodeRef).value = $event))
              }, null, 8, ["site-key", "appearance", "modelValue"]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})